//====================================================
//  Remove Basket item
//====================================================

function fn_parts_remove_basket_item(){
	if ($('.js-basket-item-block').length){
		$('.js-remove-basket-item').on('click', function(e){
			$(this).closest('.js-basket-item-block').remove();
	    });
	}
}